import { pipe } from "fp-ts/lib/function";
import { TRoadblockConfiguration } from "../roadblockTypesAndCodecs";
import { array } from "fp-ts";
import { propertyDetailsAdded, propertyHasDetails } from "./Contracts";
import { Address3_displayString } from "../../codecs/Address";
import { fact } from "../evidence/evidenceHelpers";
import { TRoadblockEvidenceLink } from "../../codecs/form/RoadblockForm";

const titleChecksLink: TRoadblockEvidenceLink = { block: "case_title_checks", section: null };
const propertyDetailsLink: TRoadblockEvidenceLink = { block: "case_contracts", section: "property_details" };
const reasonForTransactionLink: TRoadblockEvidenceLink = { block: "case_contracts", section: "client_configuration" };

export const TitleChecks: TRoadblockConfiguration = {
    type: "title_checks",
    display_name: "Title Checks",
    only_create_if_resolved: [],
    requires_authoriser_signoff: false,
    blocks_exchange: true,
    create: {
        create_condition_description: "When one or more title has been added to a case",
        predicate: (c) => c.cases_properties.length > 0 && c.case.is_instructed !== null
    },
    checklist: [
        {
            type: "all_title_checks_complete",
            is_resolved_by_short_description: "All title checks completed",
            create: {
                create_condition_description: "All cases",
                predicate: () => true
            },
            resolve: {
                is_resolved_by_long_description: `Completing all title checks for all titles added to the case`,
                predicate: (c) => pipe(
                    c.cases_properties,
                    array.reduce(true, (acc, property) => property.title_check_status === "pending" ? false : acc)
                ),
                evidence: (c) => c.cases_properties.map((property) => {
                    const label = Address3_displayString(property).trim() || property.title_number || "Title";
                    const isComplete = property.title_check_status !== "pending";
                    return fact(label, isComplete ? "Complete" : "Pending", isComplete, { block: "case_title_checks", section: null });
                }),
            }
        },
        {
            type: "property_details_added",
            is_resolved_by_short_description: "Property details added",
            create: {
                create_condition_description: "All cases",
                predicate: () => true
            },
            resolve: {
                is_resolved_by_long_description: `Setting all of the property details fields on every title: tenure, address, registration status, title number and last transfer date (registered titles only), title guarantee, title class, what the title is a transfer of, and — for leasehold titles — whether the property is affected by the Building Safety Act. Also answering, once for the case, whether there is a management company.`,
                predicate: (c) => propertyDetailsAdded(c),
                evidence: (c) => [
                    ...c.cases_properties.map((property) => {
                        const label = Address3_displayString(property).trim() || property.title_number || "Title";
                        const hasDetails = propertyHasDetails(property);
                        return fact(label, hasDetails ? "Details added" : "Details incomplete", hasDetails, propertyDetailsLink);
                    }),
                    fact(
                        "Management company",
                        c.case.has_management_company === null
                            ? "Not answered"
                            : c.case.has_management_company ? "Yes" : "No",
                        c.case.has_management_company !== null,
                        propertyDetailsLink,
                    ),
                ],
            }
        },
        {
            type: "reason_for_transaction_set",
            is_resolved_by_short_description: "Reason for transaction set",
            create: {
                create_condition_description: "All cases",
                predicate: () => true
            },
            resolve: {
                is_resolved_by_long_description: `Setting the reason for the transaction on the case to anything other than unknown.`,
                predicate: (c) => c.case.seller_reason_for_sale !== "unknown",
                evidence: (c) => [
                    fact(
                        "Reason for transaction",
                        c.case.seller_reason_for_sale === "unknown" ? "Not set" : "Set",
                        c.case.seller_reason_for_sale !== "unknown",
                        reasonForTransactionLink,
                    ),
                ],
            }
        }
    ]
};